import { updateHomeLoanFundingWorksheetTotalProposedLoanAmountAndLvr } from '__core/shared/util/salestrekker';
import template from './fundingWorksheet.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    fundingWorksheets: '<',
    ticketClientTypes: '<',
    contacts: '<',
    idClients: '<',
    spouses: '<',
    income: '<',
    assets: '<',
    liabilities: '<',
    homeLoanSecurityDetails: '<',
    compareProducts: '<',
    lenders: '<',
    lendersPerCountry: '<',
    documents: '<',
    idTicket: '<',
    isSelfEmployment: '<',
    isDealOwnerBroker: '<',
    isQuickTool: '<',
    isTicketSettled: '<',
    validationErrors: '<',
    onChangeTransactionType: '&',
    onShow: '&',
    onUpdate: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $timeout,
      $mdMedia,
      eventService,
      helperService,
      ticketFactFindService,
      homeLoanService,
      financesService,
      dateTimeService,
      liabilitiesService,
      FundingWorksheet,
      FundingWorksheetFundsRequiredSplit,
      FundingWorksheetFundsAvailableSplit,
      FundingWorksheetOtherDebt,
      Address,
      Liability,
      OwnershipType,
      TransactionType
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableStates = [];
      ctrl.availableTransactionTypes = [];
      ctrl.availablePropertyStatus = [];
      ctrl.availableOwnershipTypes = [];
      ctrl.availableConstructionTypes = [];
      ctrl.availableConstructionPropertyTypes = [];
      ctrl.estimateData = [];
      ctrl.quickToolSecurities = [];
      ctrl.mortgageLenders = [];
      ctrl.fundingWorksheetParams = {};
      ctrl.validationErrors = ctrl.validationErrors || [];
      ctrl.isCrossCollateralized = false;
      ctrl.isProcessing = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.availableStates = helperService.getAvailableAddressStates();
        ctrl.availableTransactionTypes = TransactionType.available();
        ctrl.availablePropertyStatus = helperService.getAvailablePropertyStatus();
        ctrl.availableOwnershipTypes = OwnershipType.available();
        ctrl.availableConstructionTypes = helperService.getAvailableConstructionTypes();
        ctrl.availableConstructionPropertyTypes =
          helperService.getAvailableConstructionPropertyTypes();
        ctrl.fundingWorksheets = ctrl.fundingWorksheets || FundingWorksheet.Blank();
        ctrl.ticketClientTypes = ctrl.ticketClientTypes || [];
        ctrl.contacts = _.filter(
          ctrl.contacts || [],
          (c) =>
            !helperService.isClientServicingGuarantor({
              ticketClientTypes: ctrl.ticketClientTypes,
              idContact: c?.id
            }) &&
            !helperService.isClientNonBorrowingSpouse({
              ticketClientTypes: ctrl.ticketClientTypes,
              idContact: c?.id
            }) &&
            !c.isCompany
        );
        const idClients = _.map(ctrl.contacts, 'id');
        ctrl.idClients = _.filter(ctrl.idClients || [], (i) => idClients.indexOf(i) > -1);
        ctrl.spouses = ctrl.spouses || [];
        ctrl.income = ctrl.income || [];
        ctrl.assets = ctrl.assets || [];
        ctrl.liabilities = ctrl.liabilities || [];
        ctrl.homeLoanSecurityDetails = ctrl.homeLoanSecurityDetails || null;
        ctrl.compareProducts = ctrl.compareProducts || [];
        ctrl.lenders =
          _.chain(ctrl.lenders).sortNatural('name').sortNatural('group').value() || [];
        ctrl.lendersPerCountry = ctrl.lendersPerCountry || [];
        ctrl.documents = ctrl.documents || [];
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.isSelfEmployment = ctrl.isSelfEmployment || false;
        ctrl.isDealOwnerBroker = ctrl.isDealOwnerBroker || false;
        ctrl.isQuickTool = ctrl.isQuickTool || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        if (!ctrl.isTicketSettled) {
          ctrl.removeUnknownSecurities();
        } else {
          ctrl.isReady = true;
        }
      };

      ctrl.removeUnknownSecurities = () => {
        if (!ctrl.isQuickTool) {
          const idSecurities = _.map(ctrl.homeLoanSecurityDetails?.securitySplits, 'id');
          const idSecurityOfContactsForValuation = _.map(
            ctrl.homeLoanSecurityDetails.contactsForValuation,
            'idSecurity'
          );
          const idSecurityOfTitleDetails = _.map(
            ctrl.homeLoanSecurityDetails.titleDetails,
            'idSecurity'
          );
          const idSecurityOfOtherMortgages = _.map(
            ctrl.homeLoanSecurityDetails.otherMortgages,
            'idSecurity'
          );
          const idSecurityOfFundsRequired = _.map(
            ctrl.fundingWorksheets.fundsRequired,
            'idSecurity'
          );
          const idSecurityOfFundsAvailable = _.map(
            ctrl.fundingWorksheets.fundsAvailable,
            'idSecurity'
          );
          const idSecurityOfOthers = _.uniq(
            _.compact(
              _.union(
                idSecurityOfContactsForValuation,
                idSecurityOfTitleDetails,
                idSecurityOfOtherMortgages,
                idSecurityOfFundsRequired,
                idSecurityOfFundsAvailable
              )
            )
          );
          const unknownIdSecurities = _.difference(idSecurityOfOthers, idSecurities);
          for (let s = 0; s < unknownIdSecurities?.length; s += 1) {
            ctrl.otherHomeLoanSecurityDetailsDelete(unknownIdSecurities[s]);
          }
          ctrl.setFundingWorksheet();
          ctrl.isReady = true;
        } else {
          ctrl.setQuickToolFundingWorksheet();
          ctrl.isReady = true;
        }
      };

      ctrl.otherHomeLoanSecurityDetailsDelete = (idSecurity) => {
        const data = homeLoanService.otherHomeLoanSecurityDetailsDelete(
          idSecurity,
          ctrl.homeLoanSecurityDetails,
          ctrl.fundingWorksheets
        );
        ctrl.fundingWorksheets = data.fundingWorksheets;
        ctrl.homeLoanSecurityDetails = data.homeLoanSecurityDetails;
        ctrl.fundingWorksheetChanges();
      };

      ctrl.getOtherMortgageBalance = ({ otherMortgages, idSecurity }) =>
        _.reduce(
          _.filter(otherMortgages || [], (o) => o?.idSecurity === idSecurity),
          (sum, n) => _.add(sum, helperService.isNumber(n?.balance || 0, true)),
          0
        );

      ctrl.getOtherMortgageExitCosts = ({ otherMortgages, idSecurity }) =>
        _.reduce(
          _.filter(otherMortgages || [], (o) => o?.idSecurity === idSecurity),
          (sum, n) => _.add(sum, helperService.isNumber(n?.exitCosts || 0, true)),
          0
        );

      ctrl.getFundingRequiredIdx = ({ fundsRequired, idSecurity }) =>
        _.findIndex(fundsRequired || [], (f) => f?.idSecurity === idSecurity);

      ctrl.isLmiCapitalized = ({ fundsAvailable }) =>
        _.some(fundsAvailable || [], (i) => i?.isCapitalize);

      ctrl.isNumber = (value, isFloat) => helperService.isNumber(value, isFloat);

      ctrl.setFundingWorksheet = () => {
        let canCreateFundingRequired = false;
        const len = ctrl.homeLoanSecurityDetails?.securitySplits?.length || 0;
        if (len) {
          for (let i = 0; i < len; i += 1) {
            const security = ctrl.homeLoanSecurityDetails.securitySplits[i];
            canCreateFundingRequired =
              ctrl.organizationCountry?.cca2 === 'AU'
                ? Address.hasAddress(security?.address)
                : true;
            if (canCreateFundingRequired && security?.id) {
              const idx = ctrl.getFundingRequiredIdx({
                fundsRequired: ctrl.fundingWorksheets.fundsRequired,
                idSecurity: security.id
              });
              if (idx === -1) {
                const fundRequired = FundingWorksheetFundsRequiredSplit.Blank();
                fundRequired.idSecurity = security.id;
                fundRequired.transactionType =
                  homeLoanService.getStatusOfMortgagesOfSelectedSecurity({
                    homeLoanOtherMortgages: ctrl.homeLoanSecurityDetails?.otherMortgages || [],
                    idSecurity: security?.id || undefined,
                    isNew: security?.isNew || false
                  });
                fundRequired.ownershipType = security?.ownershipType || 1;
                fundRequired.propertyStatus = 1;
                fundRequired.existingLoanBalance = !security?.isLimited
                  ? ctrl.getOtherMortgageBalance({
                      otherMortgages: ctrl.homeLoanSecurityDetails.otherMortgages,
                      idSecurity: security.id
                    })
                  : 0;
                fundRequired.exitFee = !security?.isLimited
                  ? ctrl.getOtherMortgageExitCosts({
                      otherMortgages: ctrl.homeLoanSecurityDetails.otherMortgages,
                      idSecurity: security.id
                    })
                  : 0;
                if (
                  !security?.isNew &&
                  (security?.propertyType === 13 ||
                    security?.propertyType === 14 ||
                    security?.propertyType === 15 ||
                    security?.propertyType === 16)
                ) {
                  fundRequired.purposeFunds = !security?.isLimited
                    ? _.add(
                        helperService.isNumber(security?.value || 0, false),
                        helperService.isNumber(security?.builderValue || 0, false)
                      )
                    : helperService.isNumber(security?.guaranteeAmount || 0, false);
                  fundRequired.landValue = !security?.isLimited
                    ? helperService.isNumber(security?.value || 0, false)
                    : 0;
                  fundRequired.builderContractPrice = !security?.isLimited
                    ? helperService.isNumber(security?.builderValue || 0, false)
                    : 0;
                } else if (!security?.isNew) {
                  fundRequired.purposeFunds = !security?.isLimited
                    ? helperService.isNumber(security?.value || 0, false)
                    : helperService.isNumber(security?.guaranteeAmount || 0, false);
                  if (
                    (fundRequired?.transactionType?.name === TransactionType.purchase.name &&
                      fundRequired.propertyStatus !== 2) ||
                    (fundRequired?.transactionType?.name !== TransactionType.purchase.name &&
                      (fundRequired.propertyStatus === 3 || fundRequired.propertyStatus === 5))
                  ) {
                    fundRequired.builderContractPrice = !security?.isLimited
                      ? helperService.isNumber(security?.value || 0, false)
                      : 0;
                  }
                  if (
                    (fundRequired.propertyStatus === 2 ||
                      fundRequired.propertyStatus === 3 ||
                      fundRequired.propertyStatus === 5) &&
                    fundRequired.constructionType !== 3
                  ) {
                    fundRequired.landValue = !security?.isLimited
                      ? helperService.isNumber(security?.value || 0, false)
                      : 0;
                  }
                } else {
                  fundRequired.purposeFunds = helperService.isNumber(
                    security?.value || 0,
                    false
                  );
                }
                ctrl.fundingWorksheets.fundsRequired.push(
                  FundingWorksheetFundsRequiredSplit.Build(fundRequired)
                );
              }
            }
          }

          const fALen = ctrl.fundingWorksheets?.fundsAvailable?.length || 0;
          for (let f = 0; f < fALen; f += 1) {
            if (!ctrl.fundingWorksheets.fundsAvailable[f]?.idLender) {
              ctrl.fundingWorksheets.fundsAvailable[f].idLender =
                ctrl.fundingWorksheets.fundsAvailable[0]?.idLender || ctrl.lenders[0]?.id || '';
            }
          }

          if (
            !ctrl.fundingWorksheets?.fundsAvailable?.length ||
            (ctrl.fundingWorksheets?.fundsAvailable?.length === 1 &&
              !ctrl.fundingWorksheets?.fundsAvailable[0]?.isCrossCollateralized) ||
            (!ctrl.fundingWorksheets?.fundsAvailable[0]?.isCrossCollateralized &&
              ctrl.fundingWorksheets?.fundsAvailable?.length <
                ctrl.fundingWorksheets?.fundsRequired?.length)
          ) {
            const fRLen = ctrl.fundingWorksheets?.fundsRequired?.length || 0;
            for (let f = 0; f < fRLen; f += 1) {
              if (!ctrl.fundingWorksheets?.fundsAvailable[f]) {
                const fundAvailable = FundingWorksheetFundsAvailableSplit.Blank();
                fundAvailable.idSecurity =
                  ctrl.fundingWorksheets?.fundsRequired[f]?.idSecurity || '';
                fundAvailable.idLender =
                  ctrl.fundingWorksheets?.fundsAvailable[0]?.idLender ||
                  ctrl.lenders[0]?.id ||
                  '';
                fundAvailable.isCapitalize = ctrl.isLmiCapitalized({
                  fundsAvailable: ctrl.fundingWorksheets?.fundsAvailable || []
                });
                ctrl.fundingWorksheets.fundsAvailable.push(fundAvailable);
              }
            }
          }
          if (canCreateFundingRequired) {
            ctrl.saveFundingWorksheets();
          }
        }
      };

      ctrl.setQuickToolFundingWorksheet = () => {
        ctrl.mortgageLenders = _.chain(ctrl.lendersPerCountry)
          .sortNatural('name')
          .sortNatural('group')
          .value();
        const len = ctrl.homeLoanSecurityDetails?.length || 0;
        if (len) {
          for (let i = 0; i < len; i += 1) {
            const security = ctrl.homeLoanSecurityDetails[i];
            if (security?.id) {
              ctrl.quickToolSecurities.push({
                idSecurity: security.id,
                lenderAbbreviations: []
              });
              const idx = ctrl.getFundingRequiredIdx({
                fundsRequired: ctrl.fundingWorksheets.fundsRequired,
                idSecurity: security.id
              });
              if (idx === -1) {
                const fundRequired = FundingWorksheetFundsRequiredSplit.Blank();
                fundRequired.idSecurity = security?.id || '';
                fundRequired.transactionType = TransactionType.purchase;
                fundRequired.ownershipType = OwnershipType.owner_occupied;
                fundRequired.propertyStatus = 1;
                ctrl.fundingWorksheets.fundsRequired.push(
                  FundingWorksheetFundsRequiredSplit.Build(fundRequired)
                );
                fundRequired.lenderAbbreviations = [];
              }
            }
          }

          const fALen = ctrl.fundingWorksheets?.fundsAvailable?.length || 0;
          if (fALen) {
            for (let f = 0; f < fALen; f += 1) {
              if (!ctrl.fundingWorksheets?.fundsAvailable[f]?.idLender) {
                ctrl.fundingWorksheets.fundsAvailable[f].idLender =
                  ctrl.fundingWorksheets?.fundsAvailable[0]?.idLender ||
                  ctrl.lenders[0]?.id ||
                  '';
              }
            }
          }

          if (
            !ctrl.fundingWorksheets?.fundsAvailable?.length ||
            (ctrl.fundingWorksheets?.fundsAvailable?.length === 1 &&
              !ctrl.fundingWorksheets?.fundsAvailable[0]?.isCrossCollateralized) ||
            (!ctrl.fundingWorksheets?.fundsAvailable[0]?.isCrossCollateralized &&
              ctrl.fundingWorksheets?.fundsAvailable?.length <
                ctrl.fundingWorksheets?.fundsRequired?.length)
          ) {
            const fRLen = ctrl.fundingWorksheets?.fundsRequired?.length || 0;
            for (let f = 0; f < fRLen; f += 1) {
              if (!ctrl.fundingWorksheets?.fundsAvailable[f]) {
                const fundAvailable = FundingWorksheetFundsAvailableSplit.Blank();
                fundAvailable.idSecurity =
                  ctrl.fundingWorksheets?.fundsRequired[f]?.idSecurity || '';
                fundAvailable.idLender =
                  ctrl.fundingWorksheets.fundsAvailable[0]?.idLender ||
                  ctrl.lenders[0]?.id ||
                  '';
                fundAvailable.isCapitalize = ctrl.isLmiCapitalized({
                  fundsAvailable: ctrl.fundingWorksheets?.fundsAvailable || []
                });
                ctrl.fundingWorksheets.fundsAvailable.push(fundAvailable);
              }
            }
          }
          ctrl.fundingWorksheetChanges();
        }
      };

      ctrl.toggleQuickToolSecuritiesLenders = ({ fundRequired }) => {
        if (fundRequired && fundRequired?.idSecurity) {
          const lLen = fundRequired?.lenderAbbreviations?.length || 0;
          if (lLen) {
            const mortgageLiabilityType = liabilitiesService.getAllLiabilityTypes()[0];
            ctrl.liabilities = [];
            for (let l = 0; l < lLen; l += 1) {
              const liability = Liability.build({
                name: fundRequired?.lenderAbbreviations[l],
                liabilityType: mortgageLiabilityType,
                idAsset: fundRequired.idSecurity,
                isRefinanced: true
              });
              ctrl.liabilities.push(liability);
            }
          } else {
            ctrl.liabilities = [];
          }
        }
        ctrl.fundingWorksheetChanges();
      };

      ctrl.showConstructionType = () =>
        ctrl.hasPropertyStatus({ propertyStatus: 3 }) ||
        ctrl.hasPropertyStatus({ propertyStatus: 5 });

      ctrl.showConstructionTypeField = ({ fundRequired }) => {
        if (fundRequired) {
          return fundRequired?.propertyStatus === 3 || fundRequired?.propertyStatus === 5;
        }
        return true;
      };

      ctrl.showConstructionPropertyType = () =>
        (ctrl.hasTransactionType({ transactionType: TransactionType.purchase.name }) &&
          (ctrl.hasPropertyStatus({ propertyStatus: 3 }) ||
            (ctrl.hasPropertyStatus({ propertyStatus: 5 }) &&
              !ctrl.hasConstructionType({ constructionType: 3 })))) ||
        (ctrl.hasTransactionType({ transactionType: TransactionType.refinance.name }) &&
          ctrl.hasPropertyStatus({ propertyStatus: 3 })) ||
        ((ctrl.hasTransactionType({
          transactionType: TransactionType.top_up_or_increase.name
        }) ||
          ctrl.hasTransactionType({ transactionType: TransactionType.equity_release.name })) &&
          (ctrl.hasPropertyStatus({ propertyStatus: 3 }) ||
            (ctrl.hasPropertyStatus({ propertyStatus: 5 }) &&
              !ctrl.hasConstructionType({ constructionType: 3 }))));

      ctrl.showConstructionPropertyTypeField = ({ fundRequired }) => {
        if (fundRequired) {
          return (
            (fundRequired?.transactionType?.name === TransactionType.purchase.name &&
              (fundRequired?.propertyStatus === 3 ||
                (fundRequired?.propertyStatus === 5 &&
                  fundRequired?.constructionType !== 3))) ||
            (fundRequired?.transactionType?.name === TransactionType.refinance.name &&
              fundRequired?.propertyStatus === 3) ||
            ((fundRequired?.transactionType?.name === TransactionType.top_up_or_increase.name ||
              fundRequired?.transactionType?.name === TransactionType.equity_release.name) &&
              (fundRequired?.propertyStatus === 3 ||
                (fundRequired?.propertyStatus === 5 && fundRequired?.constructionType !== 3)))
          );
        }
        return true;
      };

      ctrl.showPurchaseBuilderContractPrice = () =>
        (ctrl.hasTransactionType({ transactionType: TransactionType.purchase.name }) &&
          (ctrl.hasPropertyStatus({ propertyStatus: 1 }) ||
            ctrl.hasPropertyStatus({ propertyStatus: 3 }) ||
            ctrl.hasPropertyStatus({ propertyStatus: 4 }) ||
            ctrl.hasPropertyStatus({ propertyStatus: 5 }))) ||
        (ctrl.hasTransactionType({ transactionType: TransactionType.refinance.name }) &&
          ctrl.hasPropertyStatus({ propertyStatus: 3 })) ||
        ((ctrl.hasTransactionType({
          transactionType: TransactionType.top_up_or_increase.name
        }) ||
          ctrl.hasTransactionType({ transactionType: TransactionType.equity_release.name })) &&
          (ctrl.hasPropertyStatus({ propertyStatus: 3 }) ||
            ctrl.hasPropertyStatus({ propertyStatus: 5 })));

      ctrl.showPurchaseBuilderContractPriceField = ({ fundRequired }) => {
        if (fundRequired) {
          return (
            (fundRequired?.transactionType?.name === TransactionType.purchase.name &&
              (fundRequired?.propertyStatus === 1 ||
                fundRequired?.propertyStatus === 3 ||
                fundRequired?.propertyStatus === 4 ||
                fundRequired?.propertyStatus === 5)) ||
            (fundRequired?.transactionType?.name === TransactionType.refinance.name &&
              fundRequired?.propertyStatus === 3) ||
            ((fundRequired?.transactionType?.name === TransactionType.top_up_or_increase.name ||
              fundRequired?.transactionType?.name === TransactionType.equity_release.name) &&
              (fundRequired?.propertyStatus === 3 || fundRequired?.propertyStatus === 5))
          );
        }
        return true;
      };

      ctrl.showLandContractLandValue = () =>
        (ctrl.hasTransactionType({ transactionType: TransactionType.purchase.name }) &&
          (ctrl.hasPropertyStatus({ propertyStatus: 2 }) ||
            ctrl.hasPropertyStatus({ propertyStatus: 3 }) ||
            (ctrl.hasPropertyStatus({ propertyStatus: 5 }) &&
              !ctrl.hasConstructionType({ constructionType: 3 })))) ||
        (ctrl.hasTransactionType({ transactionType: TransactionType.refinance.name }) &&
          ctrl.hasPropertyStatus({ propertyStatus: 3 })) ||
        ((ctrl.hasTransactionType({
          transactionType: TransactionType.top_up_or_increase.name
        }) ||
          ctrl.hasTransactionType({ transactionType: TransactionType.equity_release.name })) &&
          (ctrl.hasPropertyStatus({ propertyStatus: 3 }) ||
            (ctrl.hasPropertyStatus({ propertyStatus: 5 }) &&
              !ctrl.hasConstructionType({ constructionType: 3 }))));

      ctrl.showLandContractLandValueField = ({ fundRequired }) => {
        if (fundRequired) {
          return (
            (fundRequired?.transactionType?.name === TransactionType.purchase.name &&
              (fundRequired?.propertyStatus === 2 ||
                fundRequired?.propertyStatus === 3 ||
                (fundRequired?.propertyStatus === 5 &&
                  fundRequired?.constructionType !== 3))) ||
            (fundRequired?.transactionType?.name === TransactionType.refinance.name &&
              fundRequired?.propertyStatus === 3) ||
            ((fundRequired?.transactionType?.name === TransactionType.top_up_or_increase.name ||
              fundRequired?.transactionType?.name === TransactionType.equity_release.name) &&
              (fundRequired?.propertyStatus === 3 ||
                (fundRequired?.propertyStatus === 5 && fundRequired?.constructionType !== 3)))
          );
        }
        return true;
      };

      ctrl.showDateOfContract = () =>
        (ctrl.hasTransactionType({ transactionType: TransactionType.purchase.name }) &&
          (ctrl.hasPropertyStatus({ propertyStatus: 1 }) ||
            ctrl.hasPropertyStatus({ propertyStatus: 2 }) ||
            (ctrl.hasPropertyStatus({ propertyStatus: 3 }) &&
              !ctrl.hasConstructionType({ constructionType: 4 })) ||
            ctrl.hasPropertyStatus({ propertyStatus: 4 }) ||
            (ctrl.hasPropertyStatus({ propertyStatus: 5 }) &&
              !ctrl.hasConstructionType({ constructionType: 4 })))) ||
        (ctrl.hasTransactionType({ transactionType: TransactionType.refinance.name }) &&
          ctrl.hasPropertyStatus({ propertyStatus: 3 }) &&
          !ctrl.hasConstructionType({ constructionType: 4 })) ||
        ((ctrl.hasTransactionType({
          transactionType: TransactionType.top_up_or_increase.name
        }) ||
          ctrl.hasTransactionType({ transactionType: TransactionType.equity_release.name })) &&
          (ctrl.hasPropertyStatus({ propertyStatus: 3 }) ||
            ctrl.hasPropertyStatus({ propertyStatus: 5 })) &&
          !ctrl.hasConstructionType({ constructionType: 4 }));

      ctrl.showDateOfContractField = ({ fundRequired }) => {
        if (fundRequired) {
          return (
            (fundRequired?.transactionType?.name === TransactionType.purchase.name &&
              (fundRequired?.propertyStatus === 1 ||
                fundRequired?.propertyStatus === 2 ||
                (fundRequired?.propertyStatus === 3 && fundRequired?.constructionType !== 4) ||
                fundRequired?.propertyStatus === 4 ||
                (fundRequired?.propertyStatus === 5 &&
                  fundRequired?.constructionType !== 4))) ||
            (fundRequired?.transactionType?.name === TransactionType.refinance.name &&
              fundRequired?.propertyStatus === 3 &&
              fundRequired?.constructionType !== 4) ||
            ((fundRequired?.transactionType?.name === TransactionType.top_up_or_increase.name ||
              fundRequired?.transactionType?.name === TransactionType.equity_release.name) &&
              (fundRequired?.propertyStatus === 3 || fundRequired?.propertyStatus === 5) &&
              fundRequired?.constructionType !== 4)
          );
        }
        return true;
      };

      ctrl.showFirstHomeBuyer = () =>
        (ctrl.hasTransactionType({ transactionType: TransactionType.purchase.name }) &&
          (ctrl.hasPropertyStatus({ propertyStatus: 1 }) ||
            ctrl.hasPropertyStatus({ propertyStatus: 1 }) ||
            ctrl.hasPropertyStatus({ propertyStatus: 2 }) ||
            ctrl.hasPropertyStatus({ propertyStatus: 3 }) ||
            ctrl.hasPropertyStatus({ propertyStatus: 4 }) ||
            (ctrl.hasPropertyStatus({ propertyStatus: 5 }) &&
              !ctrl.hasConstructionType({ constructionType: 3 })))) ||
        (ctrl.hasTransactionType({ transactionType: TransactionType.refinance.name }) &&
          ctrl.hasPropertyStatus({ propertyStatus: 3 })) ||
        ((ctrl.hasTransactionType({
          transactionType: TransactionType.top_up_or_increase.name
        }) ||
          ctrl.hasTransactionType({ transactionType: TransactionType.equity_release.name })) &&
          (ctrl.hasPropertyStatus({ propertyStatus: 3 }) ||
            (ctrl.hasPropertyStatus({ propertyStatus: 5 }) &&
              !ctrl.hasConstructionType({ constructionType: 3 }))));

      ctrl.showFirstHomeBuyerField = ({ fundRequired }) => {
        if (fundRequired) {
          return (
            (fundRequired?.transactionType?.name === TransactionType.purchase.name &&
              (fundRequired?.propertyStatus === 1 ||
                fundRequired?.propertyStatus === 2 ||
                fundRequired?.propertyStatus === 3 ||
                fundRequired?.propertyStatus === 4 ||
                (fundRequired?.propertyStatus === 5 &&
                  fundRequired?.constructionType !== 3))) ||
            (fundRequired?.transactionType?.name === TransactionType.refinance.name &&
              fundRequired?.propertyStatus === 3) ||
            ((fundRequired?.transactionType?.name === TransactionType.top_up_or_increase.name ||
              fundRequired?.transactionType?.name === TransactionType.equity_release.name) &&
              (fundRequired?.propertyStatus === 3 ||
                (fundRequired?.propertyStatus === 5 && fundRequired?.constructionType !== 3)))
          );
        }
        return true;
      };

      ctrl.showExistingLoanBalance = () =>
        (ctrl.hasTransactionType({ transactionType: TransactionType.purchase.name }) &&
          ctrl.hasPropertyStatus({ propertyStatus: 5 })) ||
        ctrl.hasTransactionType({ transactionType: TransactionType.refinance.name }) ||
        ctrl.hasTransactionType({ transactionType: TransactionType.top_up_or_increase.name }) ||
        ctrl.hasTransactionType({ transactionType: TransactionType.equity_release.name });

      ctrl.showExistingLoanBalanceField = ({ fundRequired }) => {
        if (fundRequired) {
          return (
            (fundRequired?.transactionType?.name === TransactionType.purchase.name &&
              fundRequired?.propertyStatus === 5) ||
            fundRequired?.transactionType?.name === TransactionType.refinance.name ||
            fundRequired?.transactionType?.name === TransactionType.top_up_or_increase.name ||
            fundRequired?.transactionType?.name === TransactionType.equity_release.name
          );
        }
        return true;
      };

      ctrl.showExitFee = () =>
        ctrl.hasTransactionType({ transactionType: TransactionType.refinance.name });

      ctrl.showExitFeeField = ({ fundRequired }) =>
        fundRequired?.transactionType?.name === TransactionType.refinance.name;

      ctrl.showOtherLoansAgainstSecurity = () =>
        (ctrl.hasTransactionType({ transactionType: TransactionType.purchase.name }) &&
          ctrl.hasPropertyStatus({ propertyStatus: 5 })) ||
        ctrl.hasTransactionType({ transactionType: TransactionType.top_up_or_increase.name }) ||
        ctrl.hasTransactionType({ transactionType: TransactionType.equity_release.name });

      ctrl.showOtherLoansAgainstSecurityField = ({ fundRequired }) => {
        if (fundRequired) {
          return (
            (fundRequired?.transactionType?.name === TransactionType.purchase.name &&
              fundRequired?.propertyStatus === 5) ||
            fundRequired?.transactionType?.name === TransactionType.top_up_or_increase.name ||
            fundRequired?.transactionType?.name === TransactionType.equity_release.name
          );
        }
        return true;
      };

      ctrl.showLmiPremiumAlreadyPaidexcludingStampDuty = () =>
        (ctrl.hasTransactionType({ transactionType: TransactionType.purchase.name }) &&
          ctrl.hasPropertyStatus({ propertyStatus: 5 })) ||
        ctrl.hasTransactionType({ transactionType: TransactionType.refinance.name }) ||
        ctrl.hasTransactionType({ transactionType: TransactionType.top_up_or_increase.name }) ||
        ctrl.hasTransactionType({ transactionType: TransactionType.equity_release.name });

      ctrl.showLmiPremiumAlreadyPaidexcludingStampDutyField = ({ fundRequired }) => {
        if (fundRequired) {
          return (
            (fundRequired?.transactionType?.name === TransactionType.purchase.name &&
              fundRequired?.propertyStatus === 5) ||
            fundRequired?.transactionType?.name === TransactionType.refinance.name ||
            fundRequired?.transactionType?.name === TransactionType.top_up_or_increase.name ||
            fundRequired?.transactionType?.name === TransactionType.equity_release.name
          );
        }
        return true;
      };

      ctrl.showStampDuty = () =>
        ctrl.organizationCountry.cca2 === 'AU' &&
        ctrl.hasTransactionType({ transactionType: TransactionType.purchase.name }) &&
        (ctrl.hasPropertyStatus({ propertyStatus: 1 }) ||
          ctrl.hasPropertyStatus({ propertyStatus: 2 }) ||
          ctrl.hasPropertyStatus({ propertyStatus: 3 }) ||
          ctrl.hasPropertyStatus({ propertyStatus: 4 }));

      ctrl.showStampDutyField = ({ fundRequired }) => {
        if (fundRequired) {
          return (
            ctrl.organizationCountry.cca2 === 'AU' &&
            fundRequired?.transactionType?.name === TransactionType.purchase.name &&
            (fundRequired?.propertyStatus === 1 ||
              fundRequired?.propertyStatus === 2 ||
              fundRequired?.propertyStatus === 3 ||
              fundRequired?.propertyStatus === 4)
          );
        }
        return true;
      };

      ctrl.showMortgageDischargeCosts = () =>
        ctrl.hasTransactionType({ transactionType: TransactionType.refinance.name });

      ctrl.showMortgageDischargeCostsField = ({ fundRequired }) => {
        if (fundRequired) {
          return fundRequired?.transactionType?.name === TransactionType.refinance.name;
        }
        return true;
      };

      ctrl.showLandTransferFees = () =>
        ctrl.organizationCountry.cca2 === 'AU' &&
        ctrl.hasTransactionType({ transactionType: TransactionType.purchase.name }) &&
        (ctrl.hasPropertyStatus({ propertyStatus: 1 }) ||
          ctrl.hasPropertyStatus({ propertyStatus: 2 }) ||
          ctrl.hasPropertyStatus({ propertyStatus: 3 }) ||
          ctrl.hasPropertyStatus({ propertyStatus: 4 }));

      ctrl.showLandTransferFeesField = ({ fundRequired }) => {
        if (fundRequired) {
          return (
            ctrl.organizationCountry.cca2 === 'AU' &&
            fundRequired?.transactionType?.name === TransactionType.purchase.name &&
            (fundRequired?.propertyStatus === 1 ||
              fundRequired?.propertyStatus === 2 ||
              fundRequired?.propertyStatus === 3 ||
              fundRequired?.propertyStatus === 4)
          );
        }
        return true;
      };

      ctrl.showMortgageRegistrationFees = () =>
        ctrl.organizationCountry.cca2 === 'AU' &&
        (ctrl.hasTransactionType({ transactionType: TransactionType.purchase.name }) ||
          ctrl.hasTransactionType({ transactionType: TransactionType.refinance.name }) ||
          ctrl.hasTransactionType({ transactionType: TransactionType.equity_release.name }));

      ctrl.showMortgageRegistrationFeesField = ({ fundRequired }) => {
        if (fundRequired) {
          return (
            ctrl.organizationCountry.cca2 === 'AU' &&
            (fundRequired?.transactionType?.name === TransactionType.purchase.name ||
              fundRequired?.transactionType?.name === TransactionType.refinance.name ||
              fundRequired?.transactionType?.name === TransactionType.equity_release.name)
          );
        }
        return true;
      };

      ctrl.changeTransactionType = ({ fundRequired }) => {
        if (
          !ctrl.isQuickTool &&
          (fundRequired?.transactionType?.name === TransactionType.refinance.name ||
            fundRequired?.transactionType?.name === TransactionType.equity_release.name)
        ) {
          ctrl.onChangeTransactionType();
        }
        ctrl.fundsChanges({
          fund: fundRequired,
          field: 'transactionType',
          isFundRequired: true
        });
      };

      ctrl.updateSecurityValue = ({ fundRequired }) => {
        const fR = fundRequired;
        fR.purposeFunds = _.add(
          helperService.isNumber(fundRequired?.landValue || 0, false),
          helperService.isNumber(fundRequired?.builderContractPrice || 0, false)
        );
      };

      ctrl.updateTotalProposedLoanAmountAndLvr = ({
        fundAvailable,
        fundRequired,
        field,
        isCrossCollateralized
      }) => {
        const fA = fundAvailable;
        const [baseLvr, proposedLoanAmount, totalProposedLoanAmount, totalLvr] =
          updateHomeLoanFundingWorksheetTotalProposedLoanAmountAndLvr(
            ctrl.fundingWorksheets,
            fundRequired?.id || '',
            fA?.id || '',
            field || '',
            isCrossCollateralized || false
          );
        fA.baseLvr = baseLvr || 0;
        fA.proposedLoanAmount = proposedLoanAmount || 0;
        fA.totalProposedLoanAmount = totalProposedLoanAmount || 0;
        fA.totalLvr = totalLvr || 0;
      };

      ctrl.updateLmi = ({ fundAvailable, fundRequired, isExcluded, isCrossCollateralized }) => {
        const fA = fundAvailable;
        const lmiPremiumAlreadyPaid = isCrossCollateralized
          ? _.reduce(
              ctrl.fundingWorksheets?.fundsRequired || [],
              (sum, n) =>
                _.add(sum, helperService.isNumber(n?.lmiPremiumAlreadyPaid || 0, false)),
              0
            )
          : helperService.isNumber(fundRequired?.lmiPremiumAlreadyPaid || 0, false);
        if (isExcluded && !fundAvailable.isEditLmi) {
          if (lmiPremiumAlreadyPaid) {
            fA.lmi = _.subtract(fA?.originalLmi || 0, lmiPremiumAlreadyPaid);
          } else {
            fA.lmi = fA?.lmi !== fA?.originalLmi ? fA?.lmi || 0 : fA?.originalLmi || 0;
          }
        } else {
          fA.lmi = !fA?.isEditLmi
            ? _.subtract(fA?.originalLmi, lmiPremiumAlreadyPaid)
            : fA?.lmi;
        }
      };

      ctrl.capitalizeAllLmi = ({ fundAvailable }) => {
        const { isCapitalize } = fundAvailable;
        const len = ctrl.fundingWorksheets?.fundsAvailable?.length || 0;
        for (let i = 0; i < len; i += 1) {
          const fA = ctrl.fundingWorksheets.fundsAvailable[i];
          const fundRequired = homeLoanService.getFundsByType({
            fundingWorksheets: ctrl.fundingWorksheets,
            idSecurity: fA.idSecurity,
            type: 'fundsRequired'
          });
          fA.isCapitalize = isCapitalize;
          ctrl.updateTotalProposedLoanAmountAndLvr({
            fundAvailable: fA,
            fundRequired,
            isCrossCollateralized: fA?.isCrossCollateralized
          });
        }
        ctrl.fundingWorksheetChanges();
      };

      ctrl.changeLender = ({ fundAvailable }) => {
        if (ctrl.fundingWorksheets?.fundsAvailable?.length) {
          const { idLender } = fundAvailable;
          const len = ctrl.fundingWorksheets?.fundsAvailable?.length || 0;
          for (let f = 0; f < len; f += 1) {
            ctrl.fundingWorksheets.fundsAvailable[f].idLender = idLender;
          }
          ctrl.fundsChanges({ fund: fundAvailable });
        }
      };

      ctrl.fundsChanges = ({ fund, field, isFundRequired }) => {
        const idSecurity =
          fund?.idSecurity ||
          _.find(ctrl.homeLoanSecurityDetails?.securitySplits || [], (s) => s?.isPrimary)?.id;
        const fundRequired = homeLoanService.getFundsByType({
          fundingWorksheets: ctrl.fundingWorksheets,
          idSecurity,
          type: 'fundsRequired'
        });
        const fundAvailable = homeLoanService.getFundsByType({
          fundingWorksheets: ctrl.fundingWorksheets,
          idSecurity: fund?.idSecurity,
          type: 'fundsAvailable'
        });
        if (isFundRequired) {
          const fRIdx = helperService.findIndexById(
            ctrl.fundingWorksheets?.fundsRequired,
            fundRequired.id
          );
          if (fRIdx > -1 && fundAvailable) {
            if (!ctrl.showConstructionTypeField({ fundRequired })) {
              fundRequired.constructionType = 0;
            }
            if (!ctrl.showConstructionPropertyTypeField({ fundRequired })) {
              fundRequired.constructionPropertyType = 0;
            }
            if (!ctrl.showPurchaseBuilderContractPriceField({ fundRequired })) {
              fundRequired.builderContractPrice = 0;
            }
            if (!ctrl.showLandContractLandValueField({ fundRequired })) {
              fundRequired.landValue = 0;
            }
            if (!ctrl.showDateOfContractField({ fundRequired })) {
              fundRequired.contractDate = 0;
            }
            if (!ctrl.showExistingLoanBalanceField({ fundRequired })) {
              fundRequired.existingLoanBalance = 0;
            }
            if (!ctrl.showExitFeeField({ fundRequired })) {
              fundRequired.exitFee = 0;
            }
            if (!ctrl.showOtherLoansAgainstSecurityField({ fundRequired })) {
              fundRequired.otherLoansAgainstSecurity = 0;
            }
            if (!ctrl.showLmiPremiumAlreadyPaidexcludingStampDutyField({ fundRequired })) {
              fundRequired.lmiPremiumAlreadyPaid = 0;
            }
            if (!ctrl.showStampDutyField({ fundRequired })) {
              fundRequired.stampDuty = 0;
              fundRequired.isEditStampDuty = false;
            }
            if (!ctrl.showMortgageDischargeCostsField({ fundRequired })) {
              fundRequired.mortgageDischargeCosts = 0;
              fundRequired.isMortgageDischargeCostsEdited = false;
            }
            if (!ctrl.showLandTransferFeesField({ fundRequired })) {
              fundRequired.landTransferFees = 0;
              fundRequired.isEditLandTransferFees = false;
            }
            if (!ctrl.showMortgageRegistrationFeesField({ fundRequired })) {
              fundRequired.mortgageRegistrationFees = 0;
              fundRequired.isEditMortgageRegistrationFees = false;
            }
            ctrl.fundingWorksheets.fundsRequired[fRIdx] = fundRequired;
            if (field === 'transactionType' || field === 'existingLoanBalance') {
              if (
                field === 'transactionType' &&
                fundRequired.transactionType?.name === TransactionType.refinance.name
              ) {
                if (!fundRequired.propertyStatus) {
                  fundRequired.propertyStatus = 1;
                  fundRequired.constructionType = 0;
                  fundRequired.constructionPropertyType = 0;
                  fundRequired.landValue = 0;
                  fundRequired.contractDate = 0;
                  fundRequired.builderContractPrice = 0;
                }
                fundRequired.otherLoansAgainstSecurity = 0;
                fundRequired.lmiPremiumAlreadyPaid = 0;
              }
            } else if (
              fundRequired.transactionType?.name === TransactionType.top_up_or_increase.name &&
              fundRequired.propertyStatus === 5 &&
              (field === 'landValue' || field === 'builderContractPrice')
            ) {
              ctrl.updateSecurityValue({ fundRequired });
            } else if (field === 'lmiPremiumAlreadyPaid') {
              ctrl.updateLmi({
                fundAvailable,
                fundRequired,
                isExcluded: true,
                isCrossCollateralized: fundAvailable?.isCrossCollateralized
              });
            }
            ctrl.updateTotalProposedLoanAmountAndLvr({
              fundAvailable,
              fundRequired,
              field,
              isCrossCollateralized: fundAvailable?.isCrossCollateralized
            });
          }
        } else {
          const fAIdx = helperService.findIndexById(
            ctrl.fundingWorksheets?.fundsAvailable || [],
            fundAvailable?.id
          );
          if (fAIdx > -1) {
            if (field === 'lmi') {
              ctrl.updateLmi({
                fundAvailable,
                fundRequired,
                isExcluded: false,
                isCrossCollateralized: fundAvailable?.isCrossCollateralized
              });
            }
            ctrl.updateTotalProposedLoanAmountAndLvr({
              fundAvailable,
              fundRequired,
              field,
              isCrossCollateralized: fundAvailable?.isCrossCollateralized
            });
            ctrl.fundingWorksheets.fundsAvailable[fAIdx] = fundAvailable;
          }
        }
        ctrl.fundingWorksheetChanges();
      };

      ctrl.getSecurity = ({ idSecurity }) =>
        homeLoanService.getSecurity({
          homeLoanSecurities: !ctrl.isQuickTool
            ? ctrl.homeLoanSecurityDetails?.securitySplits || []
            : ctrl.homeLoanSecurityDetails || [],
          idSecurity
        });

      ctrl.getLmiEstimateValue = ({ data, idLender, key }) => {
        const lenderData = _.find(data || [], (l) => l?.id === idLender);
        let estimateLmi;
        if (lenderData?.lmiEstimate?.length) {
          if (ctrl.isCrossCollateralized) {
            estimateLmi = lenderData?.lmiEstimate[0]?.collateralizedLmi;
          } else if (
            !ctrl.isCrossCollateralized &&
            lenderData?.lmiEstimate[0]?.securities?.length
          ) {
            const eLmi = _.find(
              lenderData?.lmiEstimate[0]?.securities || [],
              (e) => e?.key === key
            );
            estimateLmi = eLmi?.lmi || 0;
          }
        }
        return estimateLmi || 0;
      };

      ctrl.getLenderLmiPerSecurity = ({ idLender, idSecurity }) =>
        ctrl.getLmiEstimateValue({
          data: ctrl.estimateData,
          idLender,
          key: idSecurity
        });

      ctrl.fundingWorksheetStampDutyFhogFeesAndLmiEstimate = () => {
        if (!ctrl.idTicket) {
          ctrl.fundingWorksheetParams = {
            lenders: ctrl.lenders || [],
            contacts: ctrl.contacts || [],
            assets: ctrl.assets || [],
            liabilities: ctrl.liabilities || [],
            homeLoanSecurities: ctrl.homeLoanSecurityDetails || [],
            fundingWorksheets: ctrl.fundingWorksheets || {},
            isSelfEmployment: ctrl.isSelfEmployment || false
          };
        }

        financesService
          .homeLoanFundingWorksheet({
            idTicket: ctrl.idTicket || '',
            fundingWorksheetParams: ctrl.fundingWorksheetParams || {}
          })
          .then((res) => {
            if (res?.status && !_.isEmpty(res?.fundingWorksheets)) {
              ctrl.fundingWorksheets = FundingWorksheet.Build(res?.fundingWorksheets);
              ctrl.estimateData = res?.lmi;
              ctrl.onUpdate({ fundingWorksheets: ctrl.fundingWorksheets });
            }
            ctrl.isProcessing = false;
          });
      };

      ctrl.getQuickToolSecurity = ({ idSecurity }) =>
        homeLoanService.getSecurity({
          homeLoanSecurities: ctrl.homeLoanSecurityDetails || [],
          idSecurity
        });

      ctrl.getSetPropertyStatus = ({ idTransactionType }) => {
        if (idTransactionType === 2) {
          const pS = helperService.getAvailablePropertyStatus();
          const idx = _.findIndex(pS, (i) => i?.id === 5);
          if (idx > -1) {
            pS.splice(idx, 1);
          }
          return pS;
        }
        return ctrl.availablePropertyStatus;
      };

      ctrl.getSetConstructionTypes = ({ idPropertyStatus }) => {
        if (idPropertyStatus === 5) {
          const cT = helperService.getAvailableConstructionTypes();
          const idx = _.findIndex(cT, (i) => i?.id === 1);
          if (idx > -1) {
            cT.splice(idx, 1);
          }
          return cT;
        }
        if (idPropertyStatus === 3) {
          const cT = helperService.getAvailableConstructionTypes();
          const idx = _.findIndex(cT, (i) => i?.id === 3);
          if (idx > -1) {
            cT.splice(idx, 1);
          }
          return cT;
        }
        return ctrl.availableConstructionTypes;
      };

      ctrl.getLenderDocument = ({ idLender }) => {
        const doc = _.find(
          ctrl.documents || [],
          (d) => d.lender[0] && d.lender[0]?.id === idLender && d?.type?.indexOf('LOGO') > -1
        );
        return doc?.url || '';
      };

      ctrl.otherDebtAdd = ($event, fundRequired) => {
        $event.stopPropagation();
        fundRequired.otherDebts.push(FundingWorksheetOtherDebt.Blank());
      };

      ctrl.otherDebtDelete = ($event, fundRequired, idx) => {
        $event.stopPropagation();
        fundRequired.otherDebts.splice(idx, 1);
        ctrl.fundingWorksheetChanges();
      };

      ctrl.getTotalFundsRequired = () => {
        let total = 0;
        let otherSum = 0;
        let otherDebtsSum = 0;
        if (
          ctrl.fundingWorksheets &&
          ctrl.fundingWorksheets.fundsRequired &&
          ctrl.fundingWorksheets.fundsRequired.length
        ) {
          for (let i = 0; i < ctrl.fundingWorksheets.fundsRequired.length; i += 1) {
            const fALen = ctrl.fundingWorksheets.fundsAvailable.length === 1 ? 0 : i;
            const { isCrossCollateralized } = ctrl.fundingWorksheets.fundsAvailable[0];
            const fundRequired = ctrl.fundingWorksheets.fundsRequired[i];

            if (fundRequired.transactionType?.name === TransactionType.purchase.name) {
              otherSum +=
                helperService.isNumber(fundRequired.stampDuty, false) +
                helperService.isNumber(fundRequired.legalFees, false) +
                helperService.isNumber(fundRequired.landTransferFees, false) +
                helperService.isNumber(fundRequired.mortgageRegistrationFees, false);
              if (fundRequired.propertyStatus === 2) {
                otherSum += helperService.isNumber(fundRequired.landValue, false);
              } else if (fundRequired.propertyStatus === 3) {
                otherSum +=
                  helperService.isNumber(fundRequired.landValue, false) +
                  helperService.isNumber(fundRequired.builderContractPrice, false);
              } else {
                otherSum += helperService.isNumber(fundRequired.builderContractPrice, false);
              }
            }

            if (fundRequired.transactionType?.name === TransactionType.refinance.name) {
              otherSum +=
                helperService.isNumber(fundRequired.existingLoanBalance, false) +
                helperService.isNumber(fundRequired.exitFee, false) +
                helperService.isNumber(fundRequired.mortgageDischargeCosts, false) +
                helperService.isNumber(fundRequired.landTransferFees, false) +
                helperService.isNumber(fundRequired.mortgageRegistrationFees, false);
              if (fundRequired.propertyStatus === 3) {
                otherSum += helperService.isNumber(fundRequired.builderContractPrice, false);
              }
            }

            if (
              fundRequired.transactionType?.name === TransactionType.top_up_or_increase.name ||
              fundRequired.transactionType?.name === TransactionType.equity_release.name
            ) {
              otherSum +=
                helperService.isNumber(fundRequired.exitFee, false) +
                helperService.isNumber(fundRequired.mortgageRegistrationFees, false);
              if (fundRequired.propertyStatus === 3 || fundRequired.propertyStatus === 5) {
                otherSum += helperService.isNumber(fundRequired.builderContractPrice, false);
              }
            }
            otherSum +=
              helperService.isNumber(fundRequired.lenderFees, false) +
              helperService.isNumber(fundRequired.otherFees, false);

            if (isCrossCollateralized) {
              otherSum +=
                i === 0
                  ? helperService.isNumber(ctrl.fundingWorksheets.fundsAvailable[0].lmi, false)
                  : 0;
            } else {
              otherSum += helperService.isNumber(
                ctrl.fundingWorksheets.fundsAvailable[fALen].lmi,
                false
              );
            }

            for (let j = 0; j < fundRequired.otherDebts.length; j += 1) {
              otherDebtsSum += fundRequired.otherDebts[j].value;
            }
            total = otherSum + otherDebtsSum;
          }
        }
        ctrl.fundingWorksheets.fundsTotal.required = total;
        return total;
      };

      ctrl.getTotalFundsAvailable = () => {
        let total = 0;
        if (ctrl.fundingWorksheets?.fundsAvailable?.length) {
          for (let i = 0; i < ctrl.fundingWorksheets.fundsAvailable.length; i += 1) {
            const fundAvailable = ctrl.fundingWorksheets.fundsAvailable[i];
            total += _.sum([
              helperService.isNumber(fundAvailable.firstHomeOwnersGrant, false),
              helperService.isNumber(fundAvailable.gift, false),
              helperService.isNumber(fundAvailable.depositPaid, false),
              helperService.isNumber(fundAvailable.otherFundsAvailable, false),
              helperService.isNumber(fundAvailable.totalProposedLoanAmount, false),
              helperService.isNumber(fundAvailable.saleProceedFunds, false),
              helperService.isNumber(fundAvailable.savings, false),
              helperService.isNumber(fundAvailable.equityFromProperty, false)
            ]);
          }
          ctrl.fundingWorksheets.fundsTotal.available = total;
        }
        return total;
      };

      ctrl.getTotalDifference = () => {
        const difference =
          ctrl.fundingWorksheets.fundsTotal.available -
          ctrl.fundingWorksheets.fundsTotal.required;
        ctrl.fundingWorksheets.fundsTotal.difference = difference;
        return difference;
      };

      ctrl.toggleAllCrossCollateralized = (fA) => {
        if (fA.isCrossCollateralized) {
          const fundAvailable = FundingWorksheetFundsAvailableSplit.Blank();
          fundAvailable.isCrossCollateralized = true;
          fundAvailable.idLender = ctrl.fundingWorksheets.fundsAvailable[0].idLender;
          for (let i = 0; i < ctrl.fundingWorksheets.fundsAvailable.length; i += 1) {
            const currentFundAvailable = ctrl.fundingWorksheets.fundsAvailable[i];
            let security = homeLoanService.getSecurity({
              homeLoanSecurities: !ctrl.isQuickTool
                ? ctrl.homeLoanSecurityDetails?.securitySplits || []
                : ctrl.homeLoanSecurityDetails || [],
              idSecurity: currentFundAvailable.idSecurity
            });
            if (!security || (security && !security.isPrimary)) {
              const firstSecurity = ctrl.fundingWorksheets.fundsRequired[0];
              security = firstSecurity;
            }
            fundAvailable.idSecurity = security.idSecurity;
            fundAvailable.proposedLoanAmount += helperService.isNumber(
              currentFundAvailable.proposedLoanAmount,
              false
            );
            fundAvailable.totalProposedLoanAmount += helperService.isNumber(
              currentFundAvailable.totalProposedLoanAmount,
              false
            );
            fundAvailable.firstHomeOwnersGrant += helperService.isNumber(
              currentFundAvailable.firstHomeOwnersGrant,
              false
            );
            fundAvailable.saleProceedFunds += helperService.isNumber(
              currentFundAvailable.saleProceedFunds,
              false
            );
            fundAvailable.savings += helperService.isNumber(
              currentFundAvailable.savings,
              false
            );
            fundAvailable.depositPaid += helperService.isNumber(
              currentFundAvailable.depositPaid,
              false
            );
            fundAvailable.equityFromProperty += helperService.isNumber(
              currentFundAvailable.equityFromProperty,
              false
            );
            fundAvailable.gift += helperService.isNumber(currentFundAvailable.gift, false);
            fundAvailable.otherFundsAvailable += helperService.isNumber(
              currentFundAvailable.otherFundsAvailable,
              false
            );
          }
          ctrl.fundingWorksheets.fundsAvailable = [];
          $timeout(() => {
            ctrl.fundingWorksheets.fundsAvailable = [fundAvailable];
            ctrl.fundsChanges({ fund: fundAvailable });
          });
        } else {
          ctrl.fundingWorksheets.fundsAvailable = [];
          const fundsAvailable = [];
          for (let f = 0; f < ctrl.fundingWorksheets.fundsRequired.length; f += 1) {
            const currentFundAvailable = FundingWorksheetFundsAvailableSplit.Blank();
            currentFundAvailable.idSecurity =
              ctrl.fundingWorksheets.fundsRequired[f].idSecurity;
            if (currentFundAvailable.idLender === '') {
              currentFundAvailable.idLender =
                f > 0 && fundsAvailable[0].idLender !== ''
                  ? fundsAvailable[0].idLender
                  : ctrl.lenders[0].id;
            }
            fundsAvailable.push(currentFundAvailable);
          }
          $timeout(() => {
            ctrl.fundingWorksheets.fundsAvailable = fundsAvailable;
            ctrl.fundingWorksheetChanges();
          });
        }
      };

      ctrl.hasTransactionType = ({ transactionType }) =>
        _.some(
          ctrl.fundingWorksheets?.fundsRequired || [],
          (f) => f?.transactionType?.name === transactionType
        );

      ctrl.hasPropertyStatus = ({ propertyStatus }) =>
        _.some(
          ctrl.fundingWorksheets?.fundsRequired || [],
          (f) => f.propertyStatus === propertyStatus
        );

      ctrl.hasConstructionType = ({ constructionType }) =>
        _.some(
          ctrl.fundingWorksheets?.fundsRequired || [],
          (f) => f.constructionType === constructionType
        );

      ctrl.hasConstructionPropertyType = (constructionPropertyType) =>
        _.some(
          ctrl.fundingWorksheets?.fundsRequired || [],
          (f) => f.constructionPropertyType === constructionPropertyType
        );

      ctrl.hasAnySecuritiesAddressStateEmpty = () => {
        if (ctrl.isQuickTool) {
          return _.some(ctrl?.homeLoanSecurityDetails || [], (s) => !s?.address?.state);
        }
        return false;
      };

      ctrl.hasAnySecuritiesAddressPostCodeEmpty = () => {
        if (ctrl.isQuickTool) {
          return _.some(ctrl.homeLoanSecurityDetails || [], (s) => !s?.address?.postCode);
        }
        return false;
      };

      ctrl.hasAnySecuritiesValueEmpty = () =>
        _.some(ctrl.fundingWorksheets?.fundsRequired || [], (f) => f.purposeFunds === 0);

      ctrl.hasAnyTransactionTypeEmpty = () =>
        _.some(
          ctrl.fundingWorksheets?.fundsRequired || [],
          (f) => f?.transactionType?.name === TransactionType.none.name
        );

      ctrl.hasAnyOwnershipTypeEmpty = () =>
        _.some(
          ctrl.fundingWorksheets?.fundsRequired || [],
          (f) => f?.ownershipType?.name === OwnershipType.none.name
        );

      ctrl.hasAnyPropertyStatusEmpty = () =>
        _.some(
          ctrl.fundingWorksheets?.fundsRequired || [],
          (f) =>
            (f.propertyStatus === null || f.propertyStatus === '') &&
            f?.transactionType?.name !== TransactionType.none.name
        );

      ctrl.getFundsClass = (number) => ticketFactFindService.setFundClass(number);

      ctrl.areAllRequiredFieldsFilled = () => {
        const collection = [];
        const len = ctrl.fundingWorksheets?.fundsRequired?.length || 0;
        for (let i = 0; i < len; i += 1) {
          const fundRequired = ctrl.fundingWorksheets.fundsRequired[i];
          collection.push(
            fundRequired?.purposeFunds > 0,
            fundRequired?.transactionType?.name !== TransactionType.none.name,
            fundRequired?.ownershipType?.name !== OwnershipType.none.name,
            fundRequired?.propertyStatus > 0
          );
          if (
            (fundRequired?.transactionType?.name === TransactionType.purchase.name &&
              fundRequired?.propertyStatus !== 2) ||
            (fundRequired?.transactionType?.name !== TransactionType.purchase.name &&
              (fundRequired?.propertyStatus === 3 || fundRequired?.propertyStatus === 5))
          ) {
            collection.push(fundRequired?.builderContractPrice > 0);
          }
          if (
            (fundRequired?.propertyStatus === 2 ||
              fundRequired?.propertyStatus === 3 ||
              fundRequired?.propertyStatus === 5) &&
            fundRequired?.constructionType !== 3
          ) {
            collection.push(fundRequired?.landValue > 0);
          }
          if (
            (fundRequired?.transactionType?.name === TransactionType.purchase.name &&
              fundRequired?.propertyStatus === 5) ||
            fundRequired?.transactionType?.name === TransactionType.refinance.name ||
            fundRequired?.transactionType?.name === TransactionType.top_up_or_increase.name ||
            fundRequired?.transactionType?.name === TransactionType.equity_release.name
          ) {
            collection.push(fundRequired?.existingLoanBalance > 0);
          }
          if (ctrl.isQuickTool) {
            collection.push(fundRequired?.state !== '', fundRequired?.postCode !== '');
          }
        }
        collection.push(
          _.every(
            ctrl.fundingWorksheets?.fundsAvailable || [],
            (f) => f?.proposedLoanAmount > 0
          )
        );
        return _.every(collection, (c) => c === true);
      };

      ctrl.hasValidationError = ({ path }) =>
        helperService.hasValidationError({ errors: ctrl.validationErrors, path });

      ctrl.showSection = () => {
        ctrl.onShow({ section: 'securityDetails' });
      };

      ctrl.showInfoMessageForVictoriaState = () => {
        const isStateVictoria = _.some(
          ctrl.isQuickTool
            ? ctrl.homeLoanSecurityDetails || []
            : ctrl.homeLoanSecurityDetails?.securitySplits || [],
          (s) => _.toLower(s?.address?.state) === 'vic'
        );
        const isPurchase = ctrl.hasTransactionType({
          transactionType: TransactionType.purchase.name
        });
        const isLandAndConstructionOrNewBuildingOrConstruction =
          ctrl.hasPropertyStatus({ propertyStatus: 3 }) ||
          ctrl.hasPropertyStatus({ propertyStatus: 4 }) ||
          ctrl.hasPropertyStatus({ propertyStatus: 5 });
        const isDateAfter = _.some(
          ctrl.fundingWorksheets?.fundsRequired || [],
          (f) =>
            f?.contractDate &&
            dateTimeService
              .getMoment(f.contractDate)
              .isAfter(dateTimeService.getMoment(1729468800))
        );
        const isOffThePlanSelected = _.some(
          ctrl.fundingWorksheets?.fundsRequired || [],
          (f) => f?.offThePlan
        );

        return _.every(
          [
            isStateVictoria,
            isPurchase,
            isLandAndConstructionOrNewBuildingOrConstruction,
            isDateAfter,
            isOffThePlanSelected
          ],
          Boolean
        );
      };

      ctrl.fundingWorksheetChanges = _.debounce(() => {
        ctrl.saveFundingWorksheets(!ctrl.areAllRequiredFieldsFilled());
      }, 3000);

      ctrl.saveFundingWorksheets = (isSilent) => {
        ctrl.isProcessing = !isSilent;
        const data = {
          securityDetails: ctrl.homeLoanSecurityDetails,
          fundingWorksheets: ctrl.fundingWorksheets,
          hLCD: !isSilent ? 'homeLoanFundingWorksheet' : ''
        };
        ctrl.onFinished({ data });
      };

      ctrl.destroyWatch = eventService.onChangedData((params) => {
        if (params?.changedData === 'homeLoanFundingWorksheet') {
          ctrl.fundingWorksheetStampDutyFhogFeesAndLmiEstimate();
        } else {
          ctrl.isProcessing = false;
        }
      });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onChanges = (changes) => {
        if (ctrl.isQuickTool && changes?.homeLoanSecurityDetails?.currentValue) {
          ctrl.isReady = false;
          ctrl.initialize();
        }
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
